import { calculateMonthlyImpliedSpend } from "../../lib/finance/projectionMath.js";

export function derivedBudgetRow(row, expenseRows = [], dateInput) {
  const irregularDelta = (row.irregularSpent ?? 0) - (row.irregularBudget ?? 0);
  const impliedOngoing = calculateMonthlyImpliedSpend(expenseRows, dateInput);
  const ongoingDelta = impliedOngoing - (row.ongoingBudget ?? 0);

  return {
    irregularDelta,
    impliedOngoing,
    ongoingDelta
  };
}
